import SVGIcon from '../SVGIcon';

interface Props {
  width: string;
  height: string;
}

function CircleXIcon({ width, height }: Props) {
  return (
    <SVGIcon width={width} height={height} viewBox="0 0 160 160" fill="none">
      <path
        id="Vector"
        d="M80 15C44.1602 15 15 44.1602 15 80C15 115.84 44.1602 145 80 145C115.84 145 145 115.84 145 80C145 44.1602 115.84 15 80 15ZM80 25C110.43 25 135 49.5703 135 80C135 110.43 110.43 135 80 135C49.5703 135 25 110.43 25 80C25 49.5703 49.5703 25 80 25ZM61.0938 53.9062L53.9062 61.0938L72.8125 80L53.9062 98.9062L61.0938 106.094L80 87.1875L98.9062 106.094L106.094 98.9062L87.1875 80L106.094 61.0938L98.9062 53.9062L80 72.8125L61.0938 53.9062Z"
        fill="#B91C1C"
      />
    </SVGIcon>
  );
}

export default CircleXIcon;
